<span class="du-toast__icon" aria-hidden="true" *ngIf="showIcon">
  <mat-icon
    *ngIf="notification.icon; else severityGlyph"
    class="du-toast__glyph"
    >{{ notification.icon }}</mat-icon
  >
  <ng-template #severityGlyph>
    <mat-icon class="du-toast__glyph" [svgIcon]="severityIcon"></mat-icon>
  </ng-template>
</span>

<div class="du-toast__content">
  <p class="du-toast__text">
    <span class="du-toast__title" *ngIf="notification.title">{{ notification.title }}</span>
    <span class="du-toast__message">{{ notification.message }}</span>
  </p>

  <button
    *ngIf="notification.action as action"
    type="button"
    class="du-toast__action"
    [attr.aria-label]="action.ariaLabel || null"
    (click)="onAction($event)"
  >
    <mat-icon *ngIf="action.icon" class="du-toast__action-icon">{{ action.icon }}</mat-icon>
    <span>{{ action.label }}</span>
  </button>
</div>

<button
  *ngIf="notification.dismissible"
  type="button"
  class="du-toast__close"
  [attr.aria-label]="closeAriaLabel"
  (click)="onClose($event)"
>
  <mat-icon class="du-toast__glyph du-toast__glyph--close" [svgIcon]="closeIcon"></mat-icon>
</button>
